var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.495 10.019L11 13.524V3a1 1 0 112 0v10.524l3.505-3.505a.875.875 0 111.239 1.238l-4.506 4.505-.884.884a.5.5 0 01-.707 0l-.885-.884-4.505-4.505a.875.875 0 111.238-1.238zm14.499 1.862c-.055-.496-.458-.881-.947-.881-.526 0-1.047.446-1.047.997v7.012l-.006.116c-.055.496-.364.881-.853.881H4.86L4.748 20C4.274 19.942 4 19.52 4 19.01v-7.012l-.006-.116C3.939 11.385 3.442 11 2.953 11c-.526 0-.953.446-.953.997v7.012l.005.176C2.092 20.755 3.336 22 4.859 22H19.14l.168-.005c1.5-.091 2.691-1.393 2.691-2.986v-7.012l-.006-.116z"
  })));
}

export default SvgDownload;